import React, { useEffect, useRef, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMobileAlt,
  FaPinterest,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import SimpleForm from "../chatbot/SimpleForm";
import styled from "styled-components";
import Hero from "../../components/Hero/Hero";
import { useDispatch, useSelector } from "react-redux";
import { getCall, getCities } from "../../Redux/Actions";
import { GET_CALL_RESET } from "../../Redux/Constants";
import Meta from "../../components/Meta";
import { Scroll } from "../../components/Scroll function/scroll";

import TopNav from "../TopNav/TopNav";
// import ImagingHeader from "./ImagingHeader";
import ImagingNewHeader from "./ImagingNewHeader";
import ImagingFooter from "./ImagingFooter";

import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import Footer from "../../components/Footer/Footer";
import SubFooter from "../../components/SubFooter/SubFooter";
import "../../Pages/ContactUs.css";
import { BrowserRouter as Router, Switch, useLocation } from "react-router-dom";
import { useHistory } from "react-router";

const Query = () => {
  useEffect(() => {
    Scroll();
  }, []);

  const history = useHistory();

  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  //GETTING DATA FROM STORE (CITIES NAME) ENDS HERE

  const location = useLocation();

  var url = `https://redcliffelabs.com` + location.pathname;

  const [name, setName] = useState("");
  const [tel, setTel] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("none");

  const [cityFocus, setCityFocus] = useState(false);

  const [message, setMessage] = useState("");
  const [checkboxState, setCheckboxState] = useState(true);

  const timer = useRef(0);

  const callRecieve = useSelector((state) => state.callRecieve);
  const { success } = callRecieve;
  // const { success } = true;

  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  const json = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Redcliffe Labs",
    image:
      "https://www.redcliffelabs.com/assets/img/logos/logo-transparent.png",
    "@id": "",
    url: "https://www.redcliffelabs.com/contact",
    telephone: "8988988787",
    priceRange: "500-2500",
    address: {
      "@type": "PostalAddress",
      streetAddress: "H55,   Sector 63, Electronic City",
      addressLocality: "Noida",
      postalCode: "201301",
      addressCountry: "IN",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 28.627941,
      longitude: 77.37493,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "08:00",
      closes: "19:00",
    },
    sameAs: [
      "https://www.facebook.com/RedcliffeLabs/",
      "https://twitter.com/Redcliffe_Labs",
      "https://www.instagram.com/redcliffelifediagnostics",
      "https://www.linkedin.com/company/redcliffe-labs/",
    ],
    department: {
      "@type": "CovidTestingFacility",
      name: "Redcliffe Labs",
      image: "https://www.redcliffelabs.com/assets/homePage/banner-1.jpg",
      telephone: "8988988787",
      priceRange: "500-1200",
      address: {
        "@type": "PostalAddress",
        streetAddress: "H55,   Sector 63, Electronic City",
        addressLocality: "Noida",
        postalCode: "201301",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "08:00",
        closes: "19:00",
      },
    },
  };

  useEffect(() => {
    dispatch(getCities());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      optin: checkboxState,
      name,
      phone_no: tel,
      source: window.innerWidth <= 600 ? "Ecommerce-mWeb" : "Ecommerce-Web",
      city: `${city}`,
      email: `${email}`,
      message: `${text ? text : "Booking_Test"}`,
      url,
    };
    // dispatch(getCall(body))
    console.log(body.phone_no);
    if (body.phone_no.length < 10 || body.phone_no.length > 11) {
      console.log("please add correct no");
      setMessageTel("Enter 10 Digit Mobile Number");
    } else {
      dispatch(getCall(body));
      setMessageTel("");
      setMessageName("");
      setText("none");
      // history.push(`${location.pathname}?utm_source=${url}`)
    }
  };

  useEffect(() => {
    if (success) {
      setName("");
      setTel("");
      setCity("");
      setEmail("");
      setText("none");
      setMessage("Your query has been submitted successfully");
      setTimeout(() => {
        dispatch({
          type: GET_CALL_RESET,
        });
        setMessage("");
      }, 5000);
    }
  }, [success]);
  const [home, setHome] = useState(false);
  //    form validation
  const [buttonDisable, setButtonDisable] = useState(true);
  const [messageName, setMessageName] = useState("");
  const [messageTel, setMessageTel] = useState("");
  const [footerTel, setTelNum] = useState("898 898 0101");
  // validation testing

  const handleNameChange = (e) => {
    // const regex = /\d/;
    const regex = /^[a-zA-Z\s]+$/g;
    console.log(regex.test(e.target.value));

    if (regex.test(e.target.value)) {
      // console.log("value is true")

      setButtonDisable(true);
      // setValue("#"+validator.trim(e.target.value)+"#")
      setMessageName("Please Enter Character Only");
    } else if (!regex.test(e.target.value)) {
      // console.log("value ifs false")
      if (e.target.value !== "") {
        setButtonDisable(false);
        setMessageName("Enter Character only");
      } else {
        setMessageName("");
      }
    } else {
      setButtonDisable(false);
      setMessageName("");
    }

    setName(e.target.value);
  };

  const handleTelChange = (e) => {
    const whitespace = / /g;
    // const whitespace = /^((\+){1}91){1}[1-9]{1}[0-9]{9}$/;
    // const whitespace = ^[7-9][0-9]{9}$;

    console.log(e.target.value[0]);
    e.preventDefault();
    //  console.log(e.target.value)
    if (
      isNaN(e.target.value) ||
      whitespace.test(e.target.value) ||
      e.target.value.length > 11 ||
      e.target.value[0] == 1 ||
      e.target.value[0] == 2 ||
      e.target.value[0] == 3 ||
      e.target.value[0] == 4 ||
      e.target.value[0] == 5
    ) {
      //  if(whitespace.test(e.target.value))
      setButtonDisable(true);
      setMessageTel("Enter 10 Digit Mobile Number");
    } else if (e.target.value[0] == 0) {
      if (
        e.target.value[1] == 1 ||
        e.target.value[1] == 2 ||
        e.target.value[1] == 3 ||
        e.target.value[1] == 4 ||
        e.target.value[1] == 5 ||
        e.target.value.length !== 11
      ) {
        setButtonDisable(true);
        setMessageTel("Enter 11 Digit Mobile Number");
      } else {
        setButtonDisable(false);
        setMessageTel("");
      }
    } else if (e.target.value[0] == "+" || e.target.value[0] == "-") {
      setButtonDisable(true);
      setMessageTel("Enter Only Mobile Number");
    } else if (e.target.value[0] !== 0) {
      if (
        e.target.value[0] == 1 ||
        e.target.value[0] == 2 ||
        e.target.value[0] == 3 ||
        e.target.value[0] == 4 ||
        e.target.value[0] == 5 ||
        e.target.value.length !== 10
      ) {
        setButtonDisable(true);
        setMessageTel("Enter 10 Digit Mobile Number");
      } else {
        setButtonDisable(false);
        setMessageTel("");
      }
    } else if (!isNaN(e.target.value)) {
      setButtonDisable(false);
      setMessageTel("");
    }
    setTel(e.target.value);
  };

  const handleOptions = (e) => {
    setText(e.target.value);
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  return (
    <React.Fragment>
      <Meta
        title="Query - Get in Touch with Redcliffe Labs"
        description="Reach us at 898-898-8787 or whatsapp or you can send us an email. We’d love to hear from you! Feel free to ask any your health related questions."
      >
        <meta
          property="og:title"
          content="Contact Us - Get in Touch with Redcliffe Labs"
        />
        <meta property="og:site_name" content="Redcliffe Labs" />
        <meta
          property="og:url"
          content="https://www.redcliffelabs.com/contact"
        />
        <meta
          property="og:description"
          content="Reach us at 898-898-8787 or whatsapp or you can send us an email. We’d love to hear from you! Feel free to ask any your health related questions."
        />
        <meta property="og:type" content="Diagnostic Centre" />
        <meta
          property="og:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="Redcliffe Labs" />
        <meta
          name="twitter:title"
          content="Contact Us - Get in Touch with Redcliffe Labs"
        />
        <meta
          name="twitter:description"
          content="Reach us at 898-898-8787 or whatsapp or you can send us an email. We’d love to hear from you! Feel free to ask any your health related questions."
        />
        <meta
          name="twitter:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />
        <script type="application/ld+json">{JSON.stringify(json)}</script>
      </Meta>
      {/* <TopNav isImagine={true} /> */}
      <ImagingNewHeader />
      <Hero text="Query" link="Contact" />
      <div className="Qureyy">
        <div className="ContactUsWrapper">
          <div className="section">
            <h5 className="head">MESSAGE US</h5>
          </div>
          <div className="container contentContainer">
            <div className="content">
              <h2 className="title">We’d Love to hear from you</h2>
              <p>
                If you have any questions or queries, our customer support team
                is always there to assist you. Feel free to contact us and we
                will get back to you as soon as possible.
              </p>
            </div>
          </div>
          <div className="formContainer">
            <form className="form container" onSubmit={handleSubmit}>
              <div className="queryTwoDiv">
                <div className="col-xs-12 col-sm-6">
                  <div className="inputContainer">
                    {/* <input value={name} type="text"  placeholder="Your Name*" onChange={(e) => setName(e.target.value)} /> */}
                    <input
                      placeholder="Enter Name"
                      onChange={handleNameChange}
                      value={name}
                    ></input>
                    <br />
                    <span style={{ color: "red", position: "absolute" }}>
                      {messageName}
                    </span>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <div className="inputContainer">
                    {/* <input value={tel} required type="tel"  placeholder="Enter Phone*" onChange={(e) => setTel(e.target.value)} /> */}
                    <input
                      required
                      placeholder="Enter Phone*"
                      onChange={handleTelChange}
                      value={tel}
                    ></input>
                    <br />
                    <span
                      style={{
                        color: "red",
                        marginBottom: "12px",
                        position: "absolute",
                        fontSize: "14px",
                      }}
                    >
                      {messageTel}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="inputContainer">
                  {/* <textarea
                  name="message"
                  id="message"
                  rows="10"
                  placeholder="Type Your Message Here*"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                ></textarea> */}

                  <select
                    required
                    style={{
                      padding: "20px",
                      backgroundColor: "#f9f9f9",
                      height: "50px",
                      width: "100%",
                      textAlign: "left",
                      padding: "10px",
                      paddingLeft: "15px",
                      fontSize: "14px",
                      fontWeight: "400",
                      border: "1px solid #eee",
                      color: "#707070",
                    }}
                    value={text}
                    onChange={(e) => {
                      handleOptions(e);
                    }}
                  >
                    <option value="none" disabled selected>
                      Select a query
                    </option>
                    <option value="Booking_Test">Booking Test</option>
                    <option value="Sample_not_Collected">
                      Sample not Collected
                    </option>
                    <option value="Report_not_Received">
                      Report not Received
                    </option>
                    <option value="Partially_report">Partial Report</option>
                  </select>
                </div>
              </div>
              <div className="opt_Div">
                <input
                  type="checkbox"
                  onChange={() => handleCheckChange()}
                  defaultChecked
                  style={{ width: "22px", height: "22px" }}
                />
                <span className="watsap">
                  <RiWhatsappFill
                    style={{ fontSize: "2.5rem", color: "#2bcc57" }}
                  />
                </span>
                <span className="textt">Opt-in for WhatsApp updates </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexGrow: 1,
                  alignItems: "center",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                }}
              >
                <div style={{ display: "flex", flexGrow: 1 }}>
                  {success && (
                    <p style={{ fontSize: "15px", color: "green" }}>
                      {message}
                    </p>
                  )}
                </div>
                <div style={{ display: "flex", flexGrow: 1 }}>
                  <button
                    disabled={
                      messageTel !== "" || messageName !== "" ? true : false
                    }
                    type="submit"
                    className="btn-primary"
                    style={{ margin: "auto" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="container contentContainer">
            <div className="content">
              <h2 className="title">
                Please get in touch and our expert support team will answer your
                questions
              </h2>
              <p>
                Please do not hesitate to get in touch with your inquiry, your
                feedback, or with any comments you might have.
              </p>
              <p className="subHead">
                Call us for instant assistance to this number
              </p>
              <h2 style={{ textAlign: "center" }}>
                <a
                  href="tel:+918988980101"
                  className="title"
                  style={{ color: "#0a406b", marginBottom: "1rem" }}
                >
                  898 898 0101
                </a>
              </h2>
              <div className="social-icons">
                <div>
                  <a
                    className="color"
                    target="_blank"
                    href="https://twitter.com/redcliffelab"
                  >
                    <FaTwitter fontSize="1.3rem" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    className="color"
                    href="https://www.youtube.com/c/RedcliffeLabs"
                  >
                    <FaYoutube fontSize="1.3rem" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    className="color"
                    href="https://in.pinterest.com/Redcliffe_Labs"
                  >
                    <FaPinterest fontSize="1.3rem" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    className="color"
                    href="https://www.facebook.com/RedcliffeLabs/"
                  >
                    <FaFacebook fontSize="1.3rem" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    className="color"
                    href="https://www.linkedin.com/company/redcliffe-labs/"
                  >
                    <FaLinkedin fontSize="1.3rem" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    className="color"
                    href="https://www.instagram.com/redcliffelabs/"
                  >
                    <FaInstagram fontSize="1.3rem" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="MapWrapper">
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.0751137405027!2d77.37355871440704!3d28.627510791060597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce523c1c96def%3A0x6010ed62e1a1f0e8!2sRedcliffe%20Lifesciences%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1620140682549!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          style={{ border: "0" }}
        ></iframe>
      </div> */}
      {/* <ScrolltoTop /> */}
      <ImagingFooter noFaq={false} telNumber={footerTel} screen={home} />
      {/* <SubFooter /> */}
      <div className="chatbot">
        <SimpleForm />
      </div>
    </React.Fragment>
  );
};

export default {
  component: Query,
};
